import {
  CheckoutCartV2,
  CheckoutCartV2BillingAddress,
  CheckoutCartV2ShippingAddress,
  CheckoutV2FinalizeCartResult,
  CheckoutV2MetaData,
  CheckoutV2PaymentMethod,
} from '@Pages/onestepcheckout'
import { NavigationStep } from '@Shared/Components/Navigation/Buble/BubbleNavigation'

export enum CheckoutFlowStep {
  ADDRESS = 'ADDRESS',
  SHIPPING = 'SHIPPING',
  SUCCESS = 'SUCCESS',
}

export interface CheckoutFlowNavigationStep extends NavigationStep<CheckoutFlowStep> {
  key: CheckoutFlowStep
  title: string | string[]
  url: string
}

export const CheckoutFlowSteps: Record<CheckoutFlowStep, CheckoutFlowNavigationStep> = {
  [CheckoutFlowStep.ADDRESS]: {
    key: CheckoutFlowStep.ADDRESS,
    title: 'checkout:COF_ADDRESS',
    url: `/?${CheckoutFlowStep.ADDRESS}`,
  },
  [CheckoutFlowStep.SHIPPING]: {
    key: CheckoutFlowStep.SHIPPING,
    title: ['checkout:SHIPPING_LABEL', 'checkout:COF_PAYMENT'],
    url: `/?${CheckoutFlowStep.SHIPPING}`,
  },
  [CheckoutFlowStep.SUCCESS]: {
    key: CheckoutFlowStep.SUCCESS,
    title: 'common:SUCCESS_LABEL',
    url: `/?${CheckoutFlowStep.SUCCESS}`,
  },
}

export const CheckoutFlowPageStepList: CheckoutFlowNavigationStep[] = [
  CheckoutFlowSteps.ADDRESS,
  CheckoutFlowSteps.SHIPPING,
  CheckoutFlowSteps.SUCCESS,
]
export type PaymentResponseCallback = (paymentType: string, finalizeCart: CheckoutV2FinalizeCartResult) => boolean
export type PaymentSubmitCallback = (finalizeCart: CheckoutV2FinalizeCartResult) => boolean
export type PaymentSubmit = <T>(paymentMethodData: T | null, submitCallback: PaymentSubmitCallback) => void

export interface CheckoutData {
  cart: CheckoutCartV2
  checkoutMeta: CheckoutV2MetaData
}

export interface CheckoutFlowPaymentType {
  payment?: CheckoutV2PaymentMethod
  terms?: boolean
}

export interface CheckoutFlowModel {
  billingAddress: CheckoutCartV2BillingAddress
  paymentStep: CheckoutFlowPaymentType
  shippingAddress: CheckoutCartV2ShippingAddress
  showShippingAddress: { checked: boolean }
  subscribeToOffers: { checked: boolean }
}

export interface CheckoutFlowContextProps {
  activeStep: CheckoutFlowNavigationStep
  data: CheckoutData
  failedNavigation: string | null
  failedNavigationAttempts: number | null
  isRecording: boolean
  model: CheckoutFlowModel
  setActiveStep: (step: CheckoutFlowNavigationStep) => void
  setShippingLoading: (shippingLoading: boolean) => void
  setSubscribeToClub: (subscribeToClub: boolean) => void
  shippingLoading: boolean
  startRecording: () => void
  stepValidations: Record<CheckoutFlowStep, boolean>
  submitCheckout: PaymentSubmit
  subscribeToClub: boolean
  updateStep: <T extends keyof CheckoutFlowModel>(
    key: keyof CheckoutFlowModel,
    update: Partial<CheckoutFlowModel[T]>,
    force?: boolean
  ) => void
  updateStepValidation: (step: CheckoutFlowStep, valid: boolean) => void
  zipCodes: Record<string, string>
}
